import { useEffect, useState } from "react";
import { trackEvent } from "../analytics";

export function usePageView(
  trackCallback: (trackFn: typeof trackEvent, opts: { url: string }) => void
) {
  const [lastUrl, setLastUrl] = useState("");
  let url = "";

  if (typeof window !== "undefined") {
    url = window.location.href;
  }

  useEffect(() => {
    if (lastUrl === url) {
      return;
    }

    trackCallback(trackEvent, { url });
    setLastUrl(url);
  }, [lastUrl, trackCallback, url]);
}
